"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZPortalLabel = void 0;
const React = __importStar(require("react"));
const core_1 = require("../../utils/core");
const useDOMNodeCallbackRef_1 = require("../../utils/useDOMNodeCallbackRef");
const kendo_react_intl_1 = require("@progress/kendo-react-intl");
const useLocalizedProps_1 = require("../../languages/useLocalizedProps");
const styled_components_1 = __importDefault(require("styled-components"));
const ZPortalLabelComponent = (props) => {
    const [currentText, setCurrentText] = React.useState("");
    const getInnerText = (node) => setCurrentText(node.innerText);
    const [textRef] = useDOMNodeCallbackRef_1.useDOMNodeCallbackRef(getInnerText);
    const intl = kendo_react_intl_1.useInternationalization();
    const { header, content, languageId, className, Id, editable, ignoreFVS, noTitle, valid, ...otherProps } = useLocalizedProps_1.useLocalizedProps(props);
    return (React.createElement("div", Object.assign({}, otherProps, { className: [className, "portal-label"].join(" ").trim() }),
        React.createElement("div", { className: "portal-label-header" }, header),
        React.createElement("div", { ref: textRef, className: "portal-label-text", title: noTitle
                ? undefined
                : content === null || content === undefined
                    ? "---"
                    : typeof content === "string"
                        ? content
                        : core_1.formattedValueToString(intl, content.props) === "---"
                            ? currentText || undefined
                            : core_1.formattedValueToString(intl, content.props) }, content === null || content === undefined ? ("---") : typeof content === "string" ? (content
            .split("\n")
            .map((line, index, lines) => lines.length > 1 ? (React.createElement("div", { key: `line-${index}` }, line)) : (line))) : React.isValidElement(content) ? (React.createElement(React.Fragment, null, content)) : (core_1.formattedValueToString(intl, { value: content })))));
};
exports.ZPortalLabel = styled_components_1.default(ZPortalLabelComponent) `
   & .portal-label-header {
      font-family: ${props => props.theme["font-family"]};
      font-size: 12px;
      color: rgba(0, 0, 0, 0.6);
      display: block;
   }
   & .portal-label-text {
      font-family: ${props => props.theme["font-family"]};
      font-size: ${props => props.fontSize || 18}px;
      color: ${props => props.theme["label-color"]};
      overflow: hidden;
      text-overflow: ellipsis;
   }
   &.disabled.disabled.disabled .portal-label-header {
      color: ${props => props.theme["disabled-color"]};
   }
   padding: 0px;
   margin: 10px 20px 10px 10px;
   width: ${props => (props.width ? `${props.width}px` : null)};
   display: inline-grid;
   vertical-align: top;
   line-height: 1.5;
   &&& {
      grid-auto-flow: row;
   }
`;
//# sourceMappingURL=ZPortalLabel.js.map